import React, {useEffect} from 'react';
import {useForm} from 'react-hook-form';
import {Box, Button, Chip, DialogActions, DialogContent, DialogTitle, TextField, Typography} from '@mui/material';
import {FindReplaceOutlined} from '@mui/icons-material';
import PropTypes from 'prop-types';
import {LandingDialog, LandingSection} from './LandingDesign';
import {SettingsDialogDescription} from '../settings/SettingsDialog';

const permittedCharacters = {
    value: /^[a-zA-Z0-9.:/?\-=&{}\\[\]()]+$/,
    message: 'Use letters, numbers or URL characters: . : / ? - = & { } [ ] ( ) \\.'
};

function BulkUpdateForLandingUrlPopUp({onClose, open, onSubmit, selectedCount}) {
    const formId = React.useId();
    const {reset, register, handleSubmit, formState: {errors}} = useForm();
    useEffect(() => {
        if (!open) reset();
    }, [open, reset]);
    const handleOnSubmit = data => {
        onSubmit(data);
        reset();
    };
    const handleClose = (event, reason) => {
        if (reason === 'backdropClick') return;
        reset();
        onClose();
    };

    return <LandingDialog open={open} onClose={handleClose} fullWidth maxWidth="sm" aria-labelledby="landing-bulk-title"
        sx={{'& .MuiDialog-paper': {borderRadius: '16px'}}}>
        <DialogTitle id="landing-bulk-title">
            <Box sx={{display: 'flex', alignItems: 'center', gap: 1.5}}>
                <FindReplaceOutlined color="primary"/>
                <Box component="span">Bulk update landing URLs</Box>
            </Box>
            <SettingsDialogDescription>Find and replace a domain, parameter or value in the selected landing URLs.</SettingsDialogDescription>
        </DialogTitle>
        <DialogContent>
            {selectedCount > 0 && <Chip label={`${selectedCount} ${selectedCount === 1 ? 'landing' : 'landings'} selected`} size="small" sx={{mb: 2}}/>}
            <Box component="form" id={formId} onSubmit={handleSubmit(handleOnSubmit)} autoComplete="off">
                <LandingSection title="Find and replace" description="Only the matching text in each URL will change.">
                    <TextField {...register('find', {required: 'Enter the text to find.', pattern: permittedCharacters})}
                        label="Find in URL *" placeholder="e.g. old-domain.com" fullWidth size="small"
                        error={!!errors.find} helperText={errors.find?.message} slotProps={{inputLabel: {shrink: true}}}/>
                    <TextField {...register('replace', {required: 'Enter the replacement text.', pattern: permittedCharacters})}
                        label="Replace with *" placeholder="e.g. new-domain.com" fullWidth size="small"
                        error={!!errors.replace} helperText={errors.replace?.message} slotProps={{inputLabel: {shrink: true}}}/>
                </LandingSection>
                <Typography sx={{fontSize: 12, color: 'text.secondary', mt: 2, lineHeight: 1.65}}>Changes apply to all selected landings.</Typography>
            </Box>
        </DialogContent>
        <DialogActions>
            <Button type="button" color="inherit" onClick={handleClose}>Cancel</Button>
            <Button type="submit" form={formId} variant="contained" startIcon={<FindReplaceOutlined/>}>Find & replace</Button>
        </DialogActions>
    </LandingDialog>;
}

BulkUpdateForLandingUrlPopUp.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    selectedCount: PropTypes.number
};

export default BulkUpdateForLandingUrlPopUp;
